// Logo URL
export const LOGO_URL = "/logo.webp";

// Team photos
export const TEAM_PHOTOS = {
  hristiyan: "/hristiyan.webp",
  desislava: "/desislava.webp",
  neli: "/neli.webp"
};

// Hero background
export const HERO_BG = "/hero.webp";

// Navigation items for multi-page
export const NAV_ITEMS = [
  { label: "Начало", href: "/" },
  { label: "За нас", href: "/za-nas" },
  { label: "Екип", href: "/ekip" },
  { label: "Услуги", href: "/uslugi" },
  { label: "Цени", href: "/ceni" },
  { label: "Блог", href: "/blog" },
  { label: "Контакти", href: "/kontakti" }
];

// Team data
export const TEAM_MEMBERS = [
  {
    name: "Християн Гешков",
    position: "Собственик & Управител",
    description: "Над 7 години опит в изходящи и входящи кампании за обслужване на клиенти. Политолог по образование.",
    image: TEAM_PHOTOS.hristiyan,
    fullDescription: "Християн е основател и управител на Outsource Point от създаването на компанията през 2016 г. С образование в областта на политологията, той успява да приложи аналитичния си подход в управлението на кол център операциите. Неговият опит включва работа по разнообразни проекти – от търговски кампании до комплексни клиентски проучвания."
  },
  {
    name: "Десислава Петкова",
    position: "Зам. Супервайзър",
    description: "С над 5 години опит в изходящите телефонни кампании, свързани с обслужването на клиенти в различни сектори.",
    image: TEAM_PHOTOS.desislava
  },
  {
    name: "Нели Мицева",
    position: "Супервайзър",
    description: "С дългогодишен опит в обслужването на клиенти и над 3 години в ръководенето на екипи в сектора на изходящите телефонни кампании.",
    image: TEAM_PHOTOS.neli
  }
];

// Services data
export const SERVICES = {
  inbound: [
    "24/7 Денонощна линия 'hotline'",
    "Front Office Customer Service",
    "First Line Customer Support"
  ],
  outbound: [
    "Обратна връзка (NPS & Customer satisfaction)",
    "Социологически и политически проучвания",
    "Търговски кампании (telesell)",
    "Организиране на срещи (Business Appointments)",
    "Прозвънявания на просрочия (Overdue clients)"
  ],
  voiceMessages: {
    title: "Еднократни Гласови Съобщения",
    description: "Изходящи гласови съобщения от всякакъв характер с възможност за пренасочване към номер на оператор при искане на клиента. Можете да избирате езика, като нямате лимит относно броя на клиентите за прозвъняване."
  },
  channels: ["WhatsApp", "Messenger", "Viber", "Instagram", "Webchat", "SMS"]
};

// Pricing data
export const PRICING = [
  { channel: "WhatsApp", monthly: "150", perTicket: "1.25" },
  { channel: "Viber", monthly: "150", perTicket: "1.25" },
  { channel: "Instagram", monthly: "150", perTicket: "1.25" },
  { channel: "Webchat", monthly: "150", perTicket: "1.25" },
  { channel: "SMS", monthly: "50", perTicket: "1.25" }
];

// Contact info
export const CONTACT_INFO = {
  email: "office@outsource-point.com",
  phone: "+359 883 027 799",
  address: "Гр. Враца, ул. Антим I, №1, Партер",
  jobsEmail: "jobs@outsource-point.com",
  facebook: "https://www.facebook.com/outsourcepointbg/",
  linkedin: "https://www.linkedin.com/company/outsource-point-ltd/"
};
